module.exports = __webpack_public_path__ + "static/media/bar-chart-icon.dd49c9ed.svg";